var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Utils from './utils';
import * as baseInfo from './baseInfo';
// 自定义 callback 函数名调用 grounds 上的方法
export const intercall = (appCommand, callback) => {
    const funName = Utils._creatFun(callback);
    grounds[appCommand](funName);
};
// 自定义 callback 函数名监听 grounds 上事件
export const onEvent = (appCommand, callback) => {
    const funName = Utils._creatFun(callback);
    grounds.on(appCommand, funName);
};
// 拉起客户端登录界面
export const userLogin = () => {
    grounds.userLogin();
};
/**
 * 执行分享
 *
 * @param shareurl   分享链接
 * @param title      标题
 * @param desc       简介
 * @param thumbnail  分享图片
 * @param documentId 分享id
 */
export const openShare = (...arg) => {
    grounds.openShare(...arg);
};
/**
 *  跳转到APP指定页面
 * type: 指定页面类型
 * url:  指定页面参数, 由type决定对应规则
 * params: 传递给客户端的其他参数，目前用于传递页面统计参数
 */
export const dispatch = (type, url, params) => {
    let isNew = baseInfo.isGVNewer('7.9.1');
    if (isNew && params) {
        grounds.dispatch(type, url, JSON.stringify(params));
    }
    else {
        grounds.dispatch(type, url);
    }
};
// 三端组件信息流跳转
export const jumpInNative = (item) => {
    switch (item.type) {
        case 'article':
            return dispatch('doc', `ucms_${item.base62Id}`, {
                showtype: item.newStyle,
            });
        case 'video':
            return dispatch('phvideo', `ucms_${item.base62Id}`, {
                showtype: item.newStyle,
            });
        case 'slide':
            return dispatch('slide', `https://nine.ifeng.com/GetNewsDocs?aid=ucms_${item.base62Id}`, {
                showtype: item.newStyle,
            });
        case 'special':
            return dispatch('topic3', `https://nine.ifeng.com/newTopic?topicid=${item.base62Id}&json=y`, {
                showtype: item.newStyle,
            });
        default:
            return dispatch('web', item.url, {
                showtype: item.newStyle,
            });
    }
};
// 推送设置页跳转
export const pushSwitch = () => {
    grounds.pushSwitch();
};
export const pushState = (callback) => {
    // FIXME：要求客户端修改 pushState 方法
    window.pushStateCallBack = (state) => {
        callback(state);
        window.pushStateCallBack = null;
    };
    grounds.pushState();
};
// 安卓通知 检查是否是系统开，端内关
export const isPushActivated = (callback) => {
    grounds.isPushActivated('isPushActivatedCallBack');
    window.isPushActivatedCallBack = (state) => {
        callback(state);
    };
};
// 跳转tab频道页
export const gotoTabMenu = (tabMenu, channelId) => {
    grounds.gotoTabMenu(tabMenu, channelId);
};
// 最大化webview
export const maximization = () => {
    if (typeof grounds.maximization !== 'undefined') {
        grounds.maximization();
    }
    if (typeof grounds.setMultiToolBarHidden !== 'undefined')
        grounds.setMultiToolBarHidden(true);
};
// 退出最大化webview
export const exitMaximization = () => {
    if (typeof grounds.exitMaximization !== 'undefined') {
        grounds.exitMaximization();
    }
    if (typeof grounds.setMultiToolBarHidden !== 'undefined')
        grounds.setMultiToolBarHidden(false);
};
// 隐藏客户端标题栏
export const setMultiToolBarHidden = (bool) => {
    if (typeof grounds.setMultiToolBarHidden !== 'undefined')
        grounds.setMultiToolBarHidden(bool);
};
// 旋转webview
// type 1 旋转到横屏 0 旋转到竖屏
export const rotate = (type) => {
    grounds.rotate(type);
};
// 关闭
export const close = () => {
    grounds.close();
};
// 设置Native分享按钮
export const setShareVisibility = (visible) => {
    grounds.setShareVisibility(visible);
};
// 拉取存储键值对
export const keyValueFetch = (key, callback) => {
    const funName = Utils._creatFun(callback);
    grounds.keyValueFetch(key, funName);
};
// 存储键值对
export const keyValueStore = (key, value) => {
    grounds.keyValueStore(key, value);
};
// 通知客户端签到成功
export const signInSuccess = () => {
    grounds.signInSuccess();
};
/**
 * 客户端代理http/https请求
 * 客户端负责拼接参数、post加密、将接口请求下拉的json数据，
 *
 * @param standards  是否需要客户端的标参.
 * @param postParams post参数键值对.
 * @param getParams  get参数键值对
 * @param type       get/post/enpost
 * @param url        base url string.
 */
export const nativeRequest = (params) => {
    params.getParams = params.getParams || '';
    params.postParams = params.postParams || '';
    params.standards = true;
    return new Promise(resolve => {
        const funName = Utils._creatFun((data) => {
            resolve(JSON.parse(decodeURIComponent(data)));
        });
        grounds.requestBridge(params.url, params.postParams, params.getParams, params.type, params.standards, funName);
    });
};
/**
 * 获取客户端本地数据
 */
export const getLocalData = (key) => {
    return new Promise((res, rej) => __awaiter(void 0, void 0, void 0, function* () {
        const callback = Utils._creatFun((data) => {
            let result = [];
            let now = Date.now();
            try {
                result = JSON.parse(data);
                if (Object.prototype.toString.call(result) !== '[object Array]')
                    throw new Error();
                result = result.filter((item) => {
                    return new Date(item.expire).valueOf() > now;
                });
            }
            catch (err) {
                console.log(err);
                grounds.keyValueStore(key, JSON.stringify([]));
            }
            res(result);
        });
        grounds.keyValueFetch(key, callback);
    }));
};
/**
 * 存储本地数据到客户端
 */
export const setLocalData = (key, data, config = {}) => {
    return new Promise((res, rej) => __awaiter(void 0, void 0, void 0, function* () {
        const { reset, expire, overWrite } = config;
        let pre = yield getLocalData(key);
        let newData = {
            create: new Date().toString(),
            expire: (expire && new Date(expire).toString()) || new Date('2999-01-01').toString(),
            content: data,
        };
        if (reset && !data) {
            pre = [];
        }
        else if (reset) {
            pre = [newData];
        }
        else {
            if (overWrite)
                pre = pre.filter((item) => item.content[overWrite] !== data[overWrite]);
            pre.push(newData);
        }
        grounds.keyValueStore(key, JSON.stringify(pre));
        res(pre);
    }));
};
